@if (shouldShow()) {
  <div
    class="tokens-warning-banner alert alert-warning d-flex align-items-center justify-content-between m-0 rounded-0 border-start-0 border-end-0"
    role="alert">
    <div class="d-flex align-items-center">
      <lucide-icon [img]="alertTriangleIcon" class="me-2 flex-shrink-0" [size]="20"></lucide-icon>
      <div>
        <strong>Warning:</strong> Your organization has less than {{ warningPercentage }}% of tokens remaining. Please upgrade
        your plan or contact support to avoid interruption.
      </div>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
}
